// frontend/src/components/notifications/Bell.jsx
/**
 * Bell — top-nav notification bell with unread badge.
 *
 * @description
 *   Top-nav icon button that shows the live unread notification count.
 *   Click opens NotificationDropdown anchored below.
 *
 * @useWhen
 *   - Mounted in the main app header for any signed-in user
 *
 * @dontUseFor
 *   - Per-page notification surfaces (use sonner toast or page-level alert)
 *
 * @related
 *   - NotificationDropdown — the dropdown that opens on click
 *   - NotificationCenter — full-page history
 *
 * @props
 *   None — reads state from NotificationsContext.
 */
import { useState } from 'react'
import { IconButton, Badge, Popover } from '@mui/material'
import NotificationsIcon from '@mui/icons-material/Notifications'
import NotificationDropdown from './NotificationDropdown'
import { useNotificationsContext } from '../../notifications/NotificationsContext'

export default function Bell() {
  const { unreadCount } = useNotificationsContext()
  const [anchor, setAnchor] = useState(null)

  return (
    <>
      <IconButton
        aria-label={`Notifications${unreadCount > 0 ? ` (${unreadCount} unread)` : ''}`}
        onClick={(e) => setAnchor(e.currentTarget)}
        size="medium"
        color="inherit"
      >
        <Badge badgeContent={unreadCount} color="primary" max={99}>
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { width: 440, maxHeight: 640 } }}
      >
        <NotificationDropdown onClose={() => setAnchor(null)} />
      </Popover>
    </>
  )
}
